import EmbeddedFormPage from './EmbeddedFormPage';

const TuitionPricingCoachingPage = () => (
  <EmbeddedFormPage
    titleKey="Tuition Pricing Coaching"
    description="Fill out this form to get started with Tuition Pricing Coaching. Tuition Pricing Coaching is a 1:1 service that helps you set rates that are competitive in your market and sustainable for your business."
    formUrl="https://wonderschool.fillout.com/t/o9uP6NkZraus"
  />
);

export default TuitionPricingCoachingPage;
